import { useNavigate } from 'react-router-dom';
import { Button, Tag } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { PageHeader } from '../../components/common/PageHeader';
import { DataTable } from '../../components/common/DataTable';
import { useTemplatesList } from '../../hooks/useSupport';
import dayjs from 'dayjs';
import type { AdminEmailTemplateItem } from '../../types/support';
import type { ColumnsType } from 'antd/es/table';

export function EmailTemplatesListPage() {
  const navigate = useNavigate();
  const { data, isLoading } = useTemplatesList();

  const columns: ColumnsType<AdminEmailTemplateItem> = [
    { title: 'Name', dataIndex: 'name', key: 'name', render: (v: string, r) => <a onClick={() => navigate(`/support/email-templates/${r.id}`)}>{v}</a> },
    { title: 'Slug', dataIndex: 'slug', key: 'slug' },
    { title: 'Subject', dataIndex: 'subject', key: 'subject', ellipsis: true },
    { title: 'Category', dataIndex: 'category', key: 'category', render: (v: string | null) => v ? <Tag>{v}</Tag> : '-' },
    {
      title: 'Status',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (v: boolean) => v ? <Tag color="green">Active</Tag> : <Tag color="red">Inactive</Tag>,
      filters: [{ text: 'Active', value: true }, { text: 'Inactive', value: false }],
      onFilter: (value, record) => record.is_active === value,
    },
    { title: 'Updated', dataIndex: 'updated_at', key: 'updated', render: (v: string) => dayjs(v).format('MMM D, YYYY') },
  ];

  return (
    <>
      <PageHeader
        title="Email Templates"
        extra={
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/support/email-templates/new')}>
            New Template
          </Button>
        }
      />
      <DataTable<AdminEmailTemplateItem> columns={columns} dataSource={data || []} loading={isLoading} total={data?.length ?? 0} perPage={10} />
    </>
  );
}
